import { Injectable } from '@angular/core';
import { AlgoliaManager } from 'src/app/data/manager/algolia/algolia.manager';
import { LocalStorageManager } from '../../data/manager/local-storage/local-storage.manager';
import { CartManager } from 'src/app/data/manager/cart/cart.manager';
import { PrimeManager } from 'src/app/data/manager/prime/prime.manager';
import { Observable } from 'rxjs/internal/Observable';
import { AddressManager } from 'src/app/data/manager/customer/address/address.manager';
import { CustomerManager } from 'src/app/data/manager/customer/customer/customer.manager';
import { of } from 'rxjs';
import { GoogleTagService } from 'src/app/data/networking/services/shared/google-tag/google-tag.service';
import { SessionStorageManager } from 'src/app/data/manager/session-storage/session-storage.manager';
import { LocationManager } from 'src/app/data/manager/location/location.manager';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PrimeVm {
  public customer: any;
  public creditCardId: any;
  public defaultCard: any;

  constructor(
    private cartManager: CartManager,
    private lsm: LocalStorageManager,
    private primeManager: PrimeManager,
    private addressManager: AddressManager,
    private customerManager: CustomerManager,
    private algoliaManager: AlgoliaManager,
    private gtmService: GoogleTagService,
    private ssm: SessionStorageManager,
    private locationManager: LocationManager,
    private store: Store<AppState>,
  ) {

  }

  hasCustomer() {
    return this.customerManager.hasValidCustomer();
  }

  getUserPlan() {
    return this.getPrimeSubscription();
  }

  primeSubscription(product): Observable<any> {
    const primeJson = {
      product,
      'quantity': 1,
      'isPrime': true
    }
    return this.cartManager.addProduct(primeJson);
  }

  getItemsPrime( id, store ): Observable<any>{
    return this.algoliaManager.getProducts( `${id}${store}` );
  }

  getDeliveryAddress() {
    return this.addressManager.getDeliveryAddress();
  }

  getPrimeConfig() {
    return this.store.select('prime').pipe(map(({config}) => this.lsm.get("primeConfig") ? this.lsm.get("primeConfig") : config));
  }

  getCustomerPrimeCart(): Observable<any> {
    this.customer = this.lsm.get("customer");
    const params = {
      idCustomerWebSafe: this.customer.idCustomerWebSafe,
      deliveryType: this.locationManager.getDeliveryType(),
      customerId: this.customer.id,
      token: this.customer?.token?.token,
      tokenIdWebSafe: this.customer?.token?.tokenIdWebSafe
    }
    return this.primeManager.getCustomerPrimeCart(this.customer.id, params);
  }




  changePrimePaymentMethod( creditCardId ) :Observable<any> {
    this.customer = this.lsm.get("customer");
    return this.primeManager.changePrimePaymentMethod( this.customer.id, creditCardId );
  }

  primeCancel():Observable<any> {
    this.customer = this.lsm.get("customer");
    this.cancelEventGtm();
    return this.primeManager.primeCancel(this.customer.id);
  }

  getPrimePlans() {
    return this.lsm.get("primeConfig")[0].prime_plans;
  }

  cancelEventGtm(){
    this.getPrimeSubscription( ).subscribe( subscription => {
      const currentPlan = this.getPrimePlans().filter( plan => plan.product_id === subscription.current_plan_sku );
      this.gtmService.cancelPrimeSubscription( currentPlan[0]?.title )
    } );
  }

  getPrimeSubscription():Observable<any>{
    if(this.lsm.get("customer")){
      this.customer = this.lsm.get("customer");
      if(this.customer.id){
        return this.primeManager.getPrimeSubscription(this.customer.id);
      }
      return of({"active": false,})
    }else{
      const id = 0;
      return this.primeManager.getPrimeSubscription(id);
    }
  }

  getPrimeCartAndSubscription(): Observable<any> {
    return this.getPrimeSubscription()
      .pipe(switchMap(responseSubscription => {
        return this.getCustomerPrimeCart()
          .pipe(map(responsePrimeCart => ({
            subscription: {...responseSubscription},
            primeCart: {...responsePrimeCart},
          })));
      }));
  }

  clearPrimePlan(){
    return this.ssm.removeItem('primeSubscription')
  }

  getTermsAndConditionsPrimeV1(){
    return this.primeManager.getTermsAndConditionsPrimev1() 
  }
}
